import React from 'react';
import { ExpandableSection } from 'AWS-UI-Components-React';
import { ViewByTimeFrame } from './view_by_timeframe';
import { aggregateByTimeframe } from './utils';

/**
 * Given a map of test results by region,
 * renders the test results putting each region
 * in an expandable section which display the
 * corresponding test results upon expansion.
 */
export class ViewByRegion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getHeader = (region) => {
    const { regionLabelsById } = this.props;
    return regionLabelsById[region] || 'Not Region Specific.';
  };

  render() {
    const { title, chart, testResultsByRegion } = this.props;

    return (
      <div>
        <h2>{title}</h2>
        <div>{chart ? chart : ''}</div>
        {Object.keys(testResultsByRegion).map((region) => {
          const byTimeFrame = aggregateByTimeframe(testResultsByRegion[region]);
          return (
            <ExpandableSection
              key={'TestResultsByRegionExpandableSection' + region}
              header={this.getHeader(region)}
              variant="borderless"
            >
              <div className="awsui-util-container">
                <ViewByTimeFrame
                  key={'TestResultsByRegionTimeFrame' + region}
                  testResultsByTimeFrame={byTimeFrame}
                  title={''}
                  loadValidationTestResults={this.props.loadValidationTestResults}
                />
              </div>
            </ExpandableSection>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/simulator/validation_test_results/view_by_region.jsx